import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberForumsPage from "@/pages/member/MemberForumsPage";

export const Route = createFileRoute("/member/forums/")({
  head: () => pageHead("Member · Forums", "AKIVA member · forums portal.", "/member/forums", true),
  component: MemberForumsPage,
});
